import React from 'react';
export const TabletLandscape = props => (
  <svg viewBox="0 0 20 20" width="16px" height="16px" {...props} className={`btfont ${props.className ? props.className : ''}`}><path d="M1 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4zm-1 8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8z" fillRule="evenodd" />,
<path d="M14 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0z" fillRule="evenodd" /></svg>
);
